import { useCallback } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'redux/store';
import { RootState } from 'redux/schemas';
import { getDashboardSummary } from 'redux/actions/dashboard';


const useDashboardSummary = () => {
  const dispatch = useAppDispatch();
  const {
    isSummaryLoading,
    onceLoaded: summaryOnceLoaded,
    summary: currentSummary,
  } = useSelector((state: RootState) => state.app.dashboardSummary);

  const loadSummary = useCallback(
    () => dispatch(getDashboardSummary()).then(unwrapResult).then(({ result }) => result),
    [dispatch],
  );

  return {
    currentSummary,
    isSummaryLoading,
    summaryOnceLoaded,
    loadSummary,
  };
};

export default useDashboardSummary;
